<div class="flex flex-column gap-3 mb-2">
  <p-panel
    #panel
    toggler="icon"
    class="search-panel"
    [toggleable]="true"
    [collapsed]="isCollapsed"
  >
    <ng-template pTemplate="header">
      <div class="flex w-full gap-2 justify-content-between">
        <div>
          <p-button
            *ngIf="isFilterButtonVisible()"
            size="small"
            label="Φίλτρα"
            icon="pi pi-filter"
            (onClick)="panel.toggle($event)"
            styleClass="{{ panel.collapsed ? 'p-button-outlined' : '' }}"
          />
          <ng-content select="[header]" />
        </div>

        <div class="flex gap-2 md:align-items-center p-button-collapsible">
          <ng-content select="[actions]" />
          <eo-action-menu-button
            *ngIf="isActionMenuButtonVisible()"
            [actions]="menuActions"
          />
        </div>
      </div>
    </ng-template>

    <ng-content />
  </p-panel>

  <!-- <app-filter-chips
      *ngIf="filters?.length != 0"
      [filters]="filters"
      (remove)="onRemoveFilter($event)"
    /> -->
</div>

<!-- <app-instructions-panel #instructionDialog [showControl]="false" /> -->
